import React, { useEffect, useState } from 'react';

const useMouseFollowTooltip = () => {
  const [globalCoords, setGlobalCoords] = useState({ x: 0, y: 0 });
  const [tooltipText, setTooltipText] = useState<string>('');

  useEffect(() => {
    const handleGlobalMouseMove = ({ clientX: x, clientY: y }: MouseEvent) => setGlobalCoords({ x, y });
    window.addEventListener('mousemove', handleGlobalMouseMove);
    return () => window.removeEventListener('mousemove', handleGlobalMouseMove);
  }, []);

  const renderTooltip = () => {
    if (!tooltipText) return null;
    const { x, y } = globalCoords;
    return (
      <div className="custom-tooltip-v2 custom-tooltip mouse-follow-tooltip">
        <div className="__react_component_tooltip place-top show" style={{ left: `${x}px`, top: `${y}px` }}>
          <p className="tooltip-message">{tooltipText}</p>
        </div>
      </div>
    );
  };

  return {
    renderTooltip,
    setTooltipText,
  };
};

export default useMouseFollowTooltip;
